import { UseFormSetError } from 'react-hook-form';

export const setFormFieldError = (errors: any, fields: Array<string>, setFieldError: UseFormSetError<any>) => {
  for (const fieldName in errors) {
    if (fields.includes(fieldName as (typeof fields)[number])) {
      setFieldError(fieldName as (typeof fields)[number], { message: errors[fieldName] });
    }
  }
};
